import React, { ReactElement, useCallback, useEffect, useState, } from 'react';
import {
    RiskMinor
} from '@shopify/polaris-icons';
import { Tabs, Scrollable, Icon, Collapsible, Link, SkeletonBodyText, Banner, Card, BlockStack, Text, Box, Bleed, Divider, InlineStack, Button, Modal, Thumbnail } from '@shopify/polaris';
import { DI, DIProps } from '../../../../../Core';
import useContextLayer from '../../Context/helper';
import noErrorFound from "../../../../../Asests/Images/no error found.png";
import { getProductErrors } from '../../utils/utils';
import useContainerState from '../../Context/ContainerState';
import Noimage from '../../../../../../public/files/noImage.png';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    allProducts: any;
    viewProductError: boolean;
    setViewProductError: React.Dispatch<React.SetStateAction<boolean>>;
    count: any;
    setCount: React.Dispatch<React.SetStateAction<any>>;
}

export const capitalizeFirstLetter = (str: string): string => {
    // Check if the input is not an empty string
    if (str && typeof str === 'string') {
        // Capitalize the first letter and concatenate the rest of the string
        return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
        // Return an empty string or the input if it's not a valid string
        return str || '';
    }
}

function ProductErrors(props: Props): ReactElement {
    const { t } = useTranslation();
    const { state, dispatch } = useContextLayer();
    const { containerState } = useContainerState();
    const [errors, setErrors] = useState<any>({ parent: [], variant: [] });
    const [answers, setAnswers] = useState<any>({})
    const { viewProductError, setViewProductError, count, setCount } = props;
    // FOR TAB WORKING
    const [selected, setSelected] = useState(0);
    const handleTabChange = useCallback((selectedTabIndex: number) => {
        setSelected(selectedTabIndex)
    }, []);
    useEffect(() => {
        state?.marketplace?.length > 0 && setProductErrors()
    }, [state.marketplace])


    // FOR COLLAPSIBLE WORKING
    const [toggleArray, setToggleArray] = useState<any>({})
    const tabs = !containerState?.product_type?.variantEdit ? state?.variants?.length > 0 ? [
        {
            id: 'product-errors',
            content: t('Parent Errors'),
            badge: count?.parent,
            accessibilityLabel: 'Product Errors',
            panelID: 'product-orders-content-1',
        },
        {
            id: 'variant-errors',
            content: t('Variant Errors'),
            badge: count?.variant,
            accessibilityLabel: 'variant Errors',
            panelID: 'variant-orders-content-1',
        },
    ] : [
        {
            id: 'product-errors',
            content: t('Parent Errors'),
            badge: count?.parent,
            accessibilityLabel: 'Product Errors',
            panelID: 'product-orders-content-1',
        },
    ] : [{
        id: 'variant-errors',
        content: t('Variant Errors'),
        badge: count?.variant,
        accessibilityLabel: 'variant Errors',
        panelID: 'variant-orders-content-1',
    }];

    const setProductErrors = () => {
        let temp = getProductErrors(state, props.redux?.current?.target._id, props.redux?.current?.source._id, count)
        setCount({ ...temp.count })
        setErrors({ ...temp.errors });
    }

    const extractUniqueTypes = (errorData: any) => {
        const uniqueArray: string[] = [];
        if (errorData && errorData.length && errorData.length > 0) {
            errorData.forEach((item: any) => {
                const { type } = item;
                if (!uniqueArray.includes(type)) {
                    uniqueArray.push(type);
                }
            });
        }
        return uniqueArray
    }

    return <>
        <Modal
            open={viewProductError}
            onClose={() => { setViewProductError(false) }}
            title={t('Errors')}
        >
            <React.Fragment>
                {(count?.parent > 0 || count?.variant > 0) &&
                    Object.keys(state).length > 0 && <div id='tour_errors'><Card padding='0' roundedAbove='sm'>
                        <BlockStack>
                            <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
                                <Scrollable shadow style={{ maxHeight: '300px' }} horizontal={false}>
                                    <Box padding='500'>
                                        {errors?.[containerState?.product_type?.variantEdit ? "variant" : !selected ? "parent" : "variant"]?.length < 1 ? <>
                                            <BlockStack inlineAlign='center' align='center' gap="400">
                                                <img src={noErrorFound} alt={t("No Errors Found!")} />
                                                <Text as='p' fontWeight='semibold'>{t("No Error Found!")}</Text>
                                            </BlockStack>
                                        </> :
                                            <BlockStack gap='400'>
                                                {errors?.[containerState?.product_type?.variantEdit ? "variant" : !selected ? "parent" : "variant"]?.map((item: any) => {
                                                    const uniqueTypes: string[] = extractUniqueTypes(item?.error);
                                                    return uniqueTypes && uniqueTypes.length > 0 && uniqueTypes.map((errorTypeCode: string, errorTypeIndex: number) => {
                                                        return <React.Fragment key={errorTypeIndex}>
                                                            <Text as='h2' variant='headingSm'>
                                                                {capitalizeFirstLetter(errorTypeCode) + ' ' + t('error(s)')}
                                                            </Text>
                                                            <Text as='h2' variant='headingSm'>
                                                                <InlineStack blockAlign='center'>
                                                                    <div className="error-product-img-container">
                                                                        <img width="100%" height="100%" src={item?.image || Noimage} alt="product" />
                                                                    </div>
                                                                    <Text as='p' fontWeight='semibold'>{item.source_product_id ?? ''}</Text>
                                                                </InlineStack>
                                                            </Text>
                                                            <BlockStack gap='400'>
                                                                {(item.error && item.error.length) && item.error.map((element: any, i: number) => {
                                                                    if (errorTypeCode == element.type) {
                                                                        return <React.Fragment key={i}>
                                                                            <InlineStack align="space-between" gap='400'>
                                                                                <InlineStack gap="200" blockAlign="center" wrap={false}>
                                                                                    <div>
                                                                                        <Icon source={RiskMinor} tone="critical"></Icon>
                                                                                    </div>
                                                                                    <div className='Custom-Stack-Item--fill'>
                                                                                        <Text as='p'>{element?.code?.toLowerCase()?.includes('amazon') ? element?.label ? <Text as='span'>{`${element?.label} : `}</Text> : <></> : <Text as='span'>{`${element?.code ?? element?.label} : `}</Text>}{element.message}</Text>
                                                                                    </div>
                                                                                </InlineStack>

                                                                            </InlineStack>
                                                                            <Collapsible
                                                                                open={toggleArray[element.message + item.toggle] ? toggleArray[element.message + item.toggle] : false}
                                                                                id="basic-collapsible"
                                                                                transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                                                                                expandOnPrint
                                                                            >
                                                                                <BlockStack gap='300'>
                                                                                    {
                                                                                        answers[element.message] ? answers[element.message] === 'false' ? <Banner title='' tone='critical'>No Answer(s) Found!</Banner> : <p dangerouslySetInnerHTML={{ __html: answers[element.message] }}></p> : <SkeletonBodyText />
                                                                                    }
                                                                                </BlockStack>
                                                                            </Collapsible>
                                                                        </React.Fragment>
                                                                    }
                                                                })}
                                                            </BlockStack>
                                                            {errorTypeIndex + 1 < item.error.length && <Divider />}
                                                        </React.Fragment>
                                                    })
                                                })}
                                            </BlockStack>
                                        }
                                    </Box>
                                </Scrollable>
                            </Tabs>
                            <Box padding="500">
                                <Text as='p'>
                                    {t("Can’t find the solution? Contact us through")} {" "}<Link url={`mailto:support@cedcommerce.com?subject=${encodeURIComponent(`${props?.di?.globalState?.get("username") ?? props?.redux?.current?.source?.name ?? "Seller"} has a question about ${process.env.REACT_APP_NAME_AND_ENV ?? "Cedcommerce Amazon Channel"}`)}`} target='_blank'>{t("Email")}</Link>{" "}

                                </Text>
                            </Box>
                        </BlockStack>
                    </Card>
                    </div>}
            </React.Fragment>
        </Modal>

    </>;
}


export default DI(ProductErrors);